import api from '../api'

// TODO: Remove this function and use the one from shared
export const getActiveQuotaMonths = async (office: string) => {
  const { data } = await api.get(`rascunho/v2/listar-mescota-aberto`, {
    params: {
      codigoEscritorio: office,
    },
  })
  return data
}
